import { TournamentPickemDetails } from "model/PickemDetails/TournamentPickemDetails";
import { nonUndefined } from "Utility";
import { mapPickemDetails } from "./FsPickemDetails";
import { FsTournamentPickemDetails } from "db/model/pickemDetails/FsTournamentPickemDetails";

export const mapTournamentPickemDetails = (
  fsModel: FsTournamentPickemDetails,
  id: string
): TournamentPickemDetails | undefined => {
  if (!fsModel.pickems || fsModel.pickems.length === 0) {
    return undefined;
  }

  return {
    pickems: mapPickemDetails(nonUndefined(fsModel.pickems), id),
    tournamentId: id,
  };
};
